import "../../utils/tailwind.css";
import { PageProvider, useBlogsProvider } from "./provider";

import Label from "../../components/label";
import Section from "../../components/section";

import Plus from "../../components/svg/plus";
import Trash from "../../components/svg/trash";
import Pencil from "../../components/svg/pencil";
import Tableloader from "../../components/table-loader";
import Button from "../../components/Buttons";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { getBlogsQuery, handleEditClick, handleWorkDelete, handleAddBlogClick, handlePageChange, currentPage, activePage, setActivePage } =
    useBlogsProvider();

  const data = getBlogsQuery?.data?.data;
  const blogs = data?.data || [];
  const paging = data?.paging || {};

  if (getBlogsQuery?.isPending) {
    return <Tableloader />;
  }

  return (
    <Section className="h-[80vh] overflow-y-auto mt-5 w-full max-w-[100%]">
      <div className="flex gap-2 mb-2 ml-3">
        <Button
          onClick={() => setActivePage("home")}
          variant={activePage === "home" ? "default" : "outline"}
          className="!text-[12px] !font-normal !w-fit !h-fit !py-2"
        >
          Home Page
        </Button>
        <Button
          onClick={() => setActivePage("login")}
          variant={activePage === "login" ? "default" : "outline"}
          className="!text-[12px] !font-normal !w-fit !h-fit !py-2"
        >
          Login Page
        </Button>
        <Button
          onClick={() => setActivePage("signup")}
          variant={activePage === "signup" ? "default" : "outline"}
          className="!text-[12px] !font-normal !w-fit !h-fit !py-2"
        >
          Signup Page
        </Button>
      </div>
      <div className="flex justify-between items-center mb-4">
        <Label className="mb-0 ml-4 text-black text-[16px] font-semibold" label="Testimonials list" />
        <div className="bg-black p-1 mr-4 rounded-full w-auto cursor-pointer" onClick={handleAddBlogClick}>
          <Plus className="text-white" />
        </div>
      </div>

      <div className="mt-3 mb-10 px-3 overflow-x-auto">
        <div className="w-full max-w-screen-2xl mx-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead className="bg-gray-200">
              <tr>
                <th className="border font-semibold border-gray-300 px-4 py-2 text-left w-[20rem]">Title</th>
                <th className="border font-semibold border-gray-300 px-4 py-2 text-left">Description</th>
                <th className="border font-semibold border-gray-300 px-4 py-2 text-left">Position</th>
                <th className="border font-semibold border-gray-300 text-left w-[70px] px-4">Action</th>
              </tr>
            </thead>
            <tbody>
              {blogs.map((item, index) => (
                <tr key={index}>
                  <td className="border border-gray-300 px-2 py-2">
                    <Label className="mb-0 text-black text-[15px]" label={item.name} />
                  </td>
                  <td className="border border-gray-300 px-2 py-2">
                    <Label className="mb-0 text-[15px]" label={item.description} />
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    <Label className="mb-0 w-60 truncate overflow-hidden text-ellipsis whitespace-nowrap text-[15px]" label={item.position} />
                  </td>
                  <td className="flex justify-between border border-gray-300 text-center py-4">
                    <Pencil className="ml-4 cursor-pointer" onClick={() => handleEditClick(item)} />
                    <Trash className="mr-4 cursor-pointer" onClick={() => handleWorkDelete(item)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="flex justify-end mt-6 pr-4 gap-2">
            {Array.from({ length: paging.total_pages }, (_, i) => i + 1).map((pageNo) => (
              <button
                key={pageNo}
                onClick={() => handlePageChange(pageNo)}
                className={`px-3 py-1 border rounded ${currentPage === pageNo ? "bg-black text-white" : "bg-white text-black"}`}
              >
                {pageNo}
              </button>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}
